import _ from 'lodash';
import moment from 'moment';

const PosServiceFactory = function PosServiceFactory($log, $q, NewBackendService, endPoints, StorageService, MovementsService) {
  'ngInject';

  const DATE_FORMAT = 'YYYYMMDD';
  //UTILS
  const getCookie = (cname) => {
      const name = cname + '=';
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(';');
      for (let i = 0; i < ca.length; i++) {
          let c = ca[i];
          while (c.charAt(0) === ' ') {
              c = c.substring(1);
          }
          if (c.indexOf(name) === 0) {
              return c.substring(name.length, c.length);
          }
      }
      return '';
  };

  const getConfigWithAccessToken = () => {
      const config = { headers: {} };
      config.headers = {};
      config.headers['Authorization'] = 'Bearer ' + getCookie('access_token');
      return config;
  };


  const hget = (path, params ) => {
      const config = getConfigWithAccessToken();
      return $http.get(path, angular.extend({params: params },config));
  };

  const service = {
    getWebPosMovements: (includeRefunds = true, fromDate, toDate, idMerchantDevice, isBackground = true) => $q((resolve, reject) => {
      NewBackendService.invokeWebApiPost('wallet_merchant/getMerchantP2PTransaction', {
        userContext: {},
        data: {
          dtoReq: {
            dtoGetMerchantP2PTransactionReq: {
              movementType: 'ALL',
              includeRefunds,
              dateFrom: fromDate && toDate ? moment(fromDate).format(DATE_FORMAT) : undefined,
              dateTo: fromDate && toDate ? moment(toDate).format(DATE_FORMAT) : undefined,
              idMerchantDevice
            }
          }
        }
      }, isBackground).then((result) => {
        if ('p2pTransactionList' in result.data.dtoRes.dtoGetUserInstrumentP2PTransactionsRes) {
          resolve(_.map(result.data.dtoRes.dtoGetUserInstrumentP2PTransactionsRes.p2pTransactionList.dtoP2PTransaction, (transaction) => {
            transaction.amount = parseFloat((transaction.amount / 100).toFixed(2)); // eslint-disable-line
            return transaction;
          }));
        } else {
          resolve([]);
        }
      }, (reason) => {
          $log.error('PosService', 'getRegisterMovements', reason);
          reject(reason);
      });
    }),
    exportCsv: (refund, dateFrom, dateTo, operator, idShop, idMerchantDevice) => {
      const userContext = JSON.parse(StorageService.getLocalStorage('userContext'));
      var filterOptions = {}
      // Il BE, per questo servizio, si aspetta sempre un range di date
      // anche se il filtro temporale non è stato impostato.
      // In attesa di una fix lato BE, in questa particolare situazione,
      // chiedo i movimenti degli ultimi 5 anni.
      const device = operator || 'ALL';
      filterOptions.walletId = userContext.context ? userContext.context.walletId : userContext.walletId
      filterOptions.merchantDeviceId = idMerchantDevice;
      filterOptions.shopId = idShop;
      if(dateFrom) filterOptions.dateStart = dateFrom //: moment().subtract(5, 'years').format(DATE_FORMAT);
      if(dateTo) filterOptions.dateEnd = dateTo //: moment().format(DATE_FORMAT);
      filterOptions.transactionTypes="PAYMENT_BUSINESS,REFUND"
      filterOptions.page = 0;
      filterOptions.size = 10000000;

      console.log(filterOptions)

      MovementsService.exportCsv(filterOptions);
      /*const url = `${endPoints.webApiUrl}static-assets/documents/getDocumentAsAttachmentFromPay/getMerchantP2PTransactionExport/${refund}/${device}/${dataDa}/${dataA}?x-authorization-eai-idwallet=${idWallet}`;
      $log.debug('url chiamato  = ', url);
      window.open(url, '_blank');*/
    },
    showPdf: (urlPdf) => {
      const url = `${endPoints.webApiUrl}static-assets/documents/invoice-creditnote${urlPdf}`;
      window.open(url, '_blank');
    },
  };

  return service;
};

export default PosServiceFactory;



/** WEBPACK FOOTER **
 ** ./client/app/common/services/pos.factory.js
 **/